import { adminConstants } from "../constant/admin-constant";

const initialState = {
    loading: false,
    brand: {},
    brands: [],
    brandsData: [], //for brandsDropdown
    brandsPaginatedData: [],
    customerBrandPermissions: [],
    taglayoutsData: [],
    addressListingData: [],
    lookupDefinitionData: [],
    transformationRulesData: {},
};
export function brandReducer(state = initialState, action) {
    switch (action.type) {
        case adminConstants.DELETE_CUSTOMER_BRAND_SUCCESS:
            return {
                ...state,
                // customerBrandPermissions: [
                //     ...state.customerBrandPermissions.filter(
                //         item => item.id !== action.payload
                //     )
                // ]
            };
        case adminConstants.STORE_CUSTOMER_BRAND_SUCCESS:
            return {
                ...state,
                customerBrandPermissions: [
                    ...state.customerBrandPermissions,
                    action.payload.result.data
                ]
            };
        case adminConstants.GET_CUSTOMER_BRANDS_SUCCESS:
            return {
                ...state,
                customerBrandPermissions: action.payload.result.customers.customer_brands.brands,
                brands: action.payload.result.customers.brands
            };
        case adminConstants.GET_BRAND_DATA_FOR_CUSTOMER_SUCCESS:
            return {
                ...state,
                brands: action.payload.result.brands
            };
        case adminConstants.GET_BRANDS_LIST_REQUEST:
            return { ...state, loading: true };
        case adminConstants.GET_BRANDS_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                current_page: action.payload.result.brands.current_page,
                pages: action.payload.result.brands.last_page,
                brandsPaginatedData: action.payload.result.brands.data
            };
        case adminConstants.GET_BRANDS_DROPDOWN_LIST_SUCCESS:
            return {
                ...state,
                brandsData: action.payload.result.brands
            };
        case adminConstants.GET_BRANDS_LIST_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case adminConstants.STORE_BRAND_REQUEST:
            return { ...state, loading: true };
        case adminConstants.STORE_BRAND_SUCCESS:
            return {
                ...state,
                loading: false,
                brand: action.payload.result.brand
            };
        case adminConstants.STORE_BRAND_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case adminConstants.STORE_BRAND_PRODUCT_ATTS_REQUEST:
            return { ...state, loading: true };
        case adminConstants.STORE_BRAND_PRODUCT_ATTS_SUCCESS:
            return { ...state, loading: false };
        case adminConstants.STORE_BRAND_PRODUCT_ATTS_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case adminConstants.STORE_BRAND_ORDER_ATTS_REQUEST:
            return { ...state, loading: true };
        case adminConstants.STORE_BRAND_ORDER_ATTS_SUCCESS:
            return { ...state, loading: false };
        case adminConstants.STORE_BRAND_ORDER_ATTS_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case adminConstants.STORE_BRAND_EXPORT_ATTS_REQUEST:
            return { ...state, loading: true };
        case adminConstants.STORE_BRAND_EXPORT_ATTS_SUCCESS:
            return { ...state, loading: false };
        case adminConstants.STORE_BRAND_EXPORT_ATTS_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case adminConstants.GET_BRAND_DATA_BYKEY_REQUEST:
            return { ...state, loading: true };
        case adminConstants.GET_BRAND_DATA_BYKEY_SUCCESS:
            return {
                ...state,
                loading: false,
                brand: action.payload.result.brand
            };
        case adminConstants.GET_BRAND_DATA_BYKEY_FAILURE:
            return { ...state, loading: false, error: action.payload };

        case adminConstants.GET_BRAND_PRODUCT_DATA_REQUEST:
            return { ...state, loading: true };
        case adminConstants.GET_BRAND_PRODUCT_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                brandProductDatacurrent_page: action.payload.result.product_data.current_page,
                brandProductDatapages: action.payload.result.product_data.last_page,
                brandProductData: action.payload.result.product_data.data,
                searchable_columns: action.payload.result.search_columns
            };
        case adminConstants.GET_BRAND_PRODUCT_DATA_FAILURE:
            return { ...state, loading: false, error: action.payload };

        case adminConstants.STORE_BRAND_DATA_DEFINITION_REQUEST:
            return { ...state, loading: true };
        case adminConstants.STORE_BRAND_DATA_DEFINITION_SUCCESS:
            return { ...state, loading: false };
        case adminConstants.STORE_BRAND_DATA_DEFINITION_FAILURE:
            return { ...state, loading: false, error: action.payload };

        case adminConstants.GET_BRAND_DATA_DEFINITIONS_REQUEST:
            return { ...state, loading: true };
        case adminConstants.GET_BRAND_DATA_DEFINITIONS_SUCCESS:
            return {
                ...state,
                loading: false,
                current_page: action.payload.result.brands.current_page,
                pages: action.payload.result.brands.last_page,
                brandDataDefinitionData: action.payload.result.brands.data
            };
        case adminConstants.GET_BRAND_DATA_DEFINITIONS_FAILURE:
            return { ...state, loading: false, error: action.payload };

        case adminConstants.EDIT_BRAND_DATA_DEFINITION_REQUEST:
            return { ...state };
        case adminConstants.EDIT_BRAND_DATA_DEFINITION_SUCCESS:
            return {
                editDataDefinition: action.payload.result.data_definition
            };
        case adminConstants.EDIT_BRAND_DATA_DEFINITION_FAILURE:
            return { ...state, error: action.payload };

        case adminConstants.PAGINATION_TAG_LAYOUTS_SUCCESS:
            return {
                ...state,
                taglayoutsData: action.payload.result.tagLayouts.data,
                pages: action.payload.result.tagLayouts.last_page,
                loading: false,
                current_page: action.payload.result.tagLayouts.current_page
            };
        case adminConstants.GET_TAG_LAYOUT_SUCCESS:
            return {
                ...state,
                taglayout: action.payload.result.tag_layout
            };

        case adminConstants.STORE_TRANSFORMATION_RULES_REQUEST:
            return { ...state };
        case adminConstants.STORE_TRANSFORMATION_RULES_SUCCESS:
            return {
                storedRule: action.payload
            };
        case adminConstants.STORE_TRANSFORMATION_RULES_FAILURE:
            return { ...state, error: action.payload };

        case adminConstants.STORE_BRAND_LOOKUP_TABLE_REQUEST:
            return { ...state };
        case adminConstants.STORE_BRAND_LOOKUP_TABLE_SUCCESS:
            return {
                storedLookup: action.payload
            };
        case adminConstants.STORE_BRAND_LOOKUP_TABLE_FAILURE:
            return { ...state, error: action.payload };

        case adminConstants.GET_BRAND_LOOKUP_DEFINITIONS_PAGINATION_REQUEST:
            return { ...state, loading: true };
        case adminConstants.GET_BRAND_LOOKUP_DEFINITIONS_PAGINATION_SUCCESS:
            return {
                ...state,
                loading: false,
                current_page: action.payload.result.lookupDefinitions.current_page,
                pages: action.payload.result.lookupDefinitions.last_page,
                lookupDefinitionPaginated: action.payload.result.lookupDefinitions.data
            };
        case adminConstants.GET_BRAND_LOOKUP_DEFINITIONS_PAGINATION_FAILURE:
            return { ...state, loading: false, error: action.payload };

        case adminConstants.GET_BRAND_LOOKUP_DEFINITIONS_DATA_REQUEST:
            return { ...state, loading: true };
        case adminConstants.GET_BRAND_LOOKUP_DEFINITIONS_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                current_page: action.payload.result.lookupDefinitions.current_page,
                pages: action.payload.result.lookupDefinitions.last_page,
                lookupDefinitionData: action.payload.result.lookupDefinitions
            };
        case adminConstants.GET_BRAND_LOOKUP_DEFINITIONS_DATA_FAILURE:
            return { ...state, loading: false, error: action.payload };

        case adminConstants.GET_TRANSFORMATION_RULES_LISTING_REQUEST:
            return { ...state };
        case adminConstants.GET_TRANSFORMATION_RULES_LISTING_SUCCESS:
            return {
                ...state,
                transformationRulesData: action.payload.result.transformation_rules
            };
        case adminConstants.GET_TRANSFORMATION_RULES_LISTING_FAILURE:
            return { ...state, error: action.payload };

        case adminConstants.MARK_ACTIVE_VERSION_DEFINITION_REQUEST:
            return { ...state };
        case adminConstants.MARK_ACTIVE_VERSION_DEFINITION_SUCCESS:
            return {
                ...state,
                activeVersion: action.payload
            };
        case adminConstants.MARK_ACTIVE_VERSION_DEFINITION_FAILURE:
            return { ...state, error: action.payload };

        case adminConstants.SORT_TRANSFORMATION_RULES_REQUEST:
            return { ...state };
        case adminConstants.SORT_TRANSFORMATION_RULES_SUCCESS:
            return {
                ...state,
                activeVersion: action.payload
            };
        case adminConstants.SORT_TRANSFORMATION_RULES_FAILURE:
            return { ...state, error: action.payload };


        case adminConstants.UPDATE_BRAND_REQUEST:
            return { ...state, loading: true };
        case adminConstants.UPDATE_BRAND_SUCCESS:
            return {
                ...state,
                loading: false,
                brand: action.payload.result.brand
            };
        case adminConstants.UPDATE_BRAND_FAILURE:
            return { ...state, loading: false, error: action.payload };

        case adminConstants.DELETE_BRAND_REQUEST:
            return { ...state, loading: true };
        case adminConstants.DELETE_BRAND_SUCCESS:
            return {
                ...state,
                loading: false,
            };
        case adminConstants.DELETE_BRAND_FAILURE:
            return { ...state, loading: false, error: action.payload };

        case adminConstants.DELETE_TRANSFORMATION_RULE_REQUEST:
            return { ...state, loading: true };
        case adminConstants.DELETE_TRANSFORMATION_RULE_SUCCESS:
            return {
                ...state,
                loading: false,
            };
        case adminConstants.DELETE_TRANSFORMATION_RULE_FAILURE:
            return { ...state, loading: false, error: action.payload };

        case adminConstants.DELETE_BRAND_DATA_DEFINITION_REQUEST:
            return { ...state, loading: true };
        case adminConstants.DELETE_BRAND_DATA_DEFINITION_SUCCESS:
            return {
                ...state,
                loading: false,
            };
        case adminConstants.DELETE_BRAND_DATA_DEFINITION_FAILURE:
            return { ...state, loading: false, error: action.payload };

        case adminConstants.GET_BRAND_SETTINGS_REQUEST:
            return { ...state, loading: true };
        case adminConstants.GET_BRAND_SETTINGS_SUCCESS:
            return {
                ...state,
                loading: false,
                brand_settings: action.payload.result.settings
            };
        case adminConstants.GET_BRAND_SETTINGS_FAILURE:
            return { ...state, loading: false, error: action.payload };

        case adminConstants.UPDATE_BRAND_SETTINGS_REQUEST:
            return { ...state };
        case adminConstants.UPDATE_BRAND_SETTINGS_SUCCESS:
            return {
                ...state,
                updatedBrandSettings: action.payload.result
            };
        case adminConstants.UPDATE_BRAND_SETTINGS_FAILURE:
            return { ...state, error: action.payload };

        default:
            return { ...state };
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/BrandReducer.jsx